// project import
import aegis from './aegis';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: aegis
};

export default menuItems;
